import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App.jsx';
import { applyTheme } from './theme/applyTheme';
import { useSettings } from './store/settings';
import './index.css';
import 'leaflet/dist/leaflet.css';

// Default theme paints first so the splash matches; the settings store
// then loads /api/settings/public and re-applies the saved theme.
applyTheme();
useSettings.getState().load();

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
            <Toaster position="top-right" toastOptions={{
                style: { background: 'var(--ag-dark)', color: '#fff', borderRadius: 12, fontSize: 14 },
                success: { iconTheme: { primary: 'var(--ag-teal)', secondary: '#fff' } },
            }} />
        </BrowserRouter>
    </React.StrictMode>
);
